import { APIURL, getData, postData, deleteData } from "../fetch";



/**
 * 
 * @param {import("./inventory").PurchaseItem} data 
 * @returns {Promise<{code: number, message: string, purchase: import("./inventory").PurchaseItem}>}
 */
const createPurchase = (data) => {
    return postData({
        url: `${APIURL}/inventory-purchases`,
        data
    })
}

/**
 * @param {import("./inventory").PurchaseItem} data 
 * @param {string} id
 * @returns {Promise<{code: number, message: string, purchase: import("./inventory").PurchaseItem}>}
 */
const updatePurchase = (data, id) => {
    return postData({
        url: `${APIURL}/inventory-purchases/${id}`,
        data
    })
}

/**
 * @returns {Promise<{code: number, message: string, purchases: import("./inventory").PurchaseItem[]}>}
 */
const getPurchases = (getAll = false, conditions = null) => {

    const obj = { url: `${APIURL}/inventory-purchases`, data: {} }

    if (getAll) obj.data = { expanded: 1 };
    if (conditions) obj.data = { ...obj.data, ...conditions }

    return getData(obj)
}

/**
 * @param {string} id 
 * @param {string[]|null} includes 
 * @returns  {Promise<{code: number, message: string, purchase: import("./inventory").PurchaseItem}>}
 */
const getPurchase = (id, includes = null) => {

    const obj = { url: `${APIURL}/inventory-purchases/${id}` };

    if (includes) obj.data = { include: includes.join(",") };

    return getData(obj);
}



const deletePurchase = id => deleteData({ url: `${APIURL}/inventory-purchases/${id}` });


export {
    createPurchase,
    getPurchase,
    getPurchases,
    updatePurchase,
    deletePurchase
}